// How an embedded map takes finger and wheel gestures. On a phone, a map
// that grabs every one-finger drag ("greedy") stops the page from scrolling
// whenever the finger lands on it (Oct 18: the wizard's Location step and the
// editor). On touch screens an inline map is "cooperative": one finger
// scrolls the page, two fingers move the map, a tap still sets a pin. Mouse
// users keep "greedy". A full-screen map (nothing else to scroll) stays greedy.
export type MapGestures = "greedy" | "cooperative";

export const inlineMapGestures = (
  coarsePointer: boolean = typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches,
): MapGestures => (coarsePointer ? "cooperative" : "greedy");
